import { i18n } from '@/plugins/i18n';
import { getRandomRGB } from '@/utils/main';
import { getRecurrenceBreakdown, getLabelsAndDatasetsFromRecurrence, recurrenceChartOptions } from '@/utils/vhub-utils';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';

/** Score based on the number of occurrences of each problem */
export default new VitalityCriterion({
  titleTr: 'VH_PB_RECURRENCE',
  key: 'problemRecurrence',
  weight: 2,
  defaultChartIndex: 1,

  score: ({ problems }, { start, end }) => {
    const filtered = problems
      .filter(p => start.isBefore(p.created) && end.isAfter(p.created));

    const breakdown = getRecurrenceBreakdown(filtered, 'recurrence', 'recurrenceWhat');

    return {
      score: breakdown.score,
      data: {
        noTopsFlops: filtered.length === 0,
        noCategoryHint: true,
        nProblems: filtered.length,
        value: breakdown.maxOccurrences,
        text: breakdown.maxText,
        itemsPerRecurrenceId: breakdown.itemsPerRecurrenceId,
      },
    };
  },

  text({ value, text, nProblems }) {
    if (nProblems === 0) {
      return i18n.t('message.VH_PB_TEXT_NONE_RELATED');
    }
    if (value > 1) {
      text = text.length > 28 ? `${text.substring(0, 25)}...` : text;
      return i18n.t('message.VH_PB_RECURRENCE_TEXT', { val: value, text });
    }
    return i18n.t('message.VH_PB_NO_RECURRENCE_TEXT');
  },

  chartData(teamGroups) {
    // Display a stacked bar chart. The item with the most NOK occurrences first and decreasing
    return getLabelsAndDatasetsFromRecurrence(teamGroups, this.scoresKey);
  },

  chartOptions() {
    return recurrenceChartOptions;
  },

  chartNames() {
    return i18n.t('message.PARETO');
  },
});
